import React from "react";
import RadioDualComponent from '../RadioDualComponent'
import ico from 'images/products/wave_solder_pallets/stiffener-bars.png'

const NeedStiffenerBar = (props) => {
  const name = 'pallet_need_stiffener_bar';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <div className="row g-0 mb-3">
      <div className="col-4 col-md-3 col-lg-4">
        <img src={ico} alt="Need Stiffener Bars" className="img-fluid mb-3" />
      </div>
      <div className="col-8 col-md-9 col-lg-8 ps-3 ps-md-0 ps-lg-3">
      <RadioDualComponent
        label="Does your pallet need stiffener bars?"
        name={name}
        inputId={props.inputId}
        onChange={onChange}
        tooltip={props.tooltip}
        parameters={props.parameters}
        className={props.className}
        required={props.required}>
        {props.children}
      </RadioDualComponent>
      </div>
    </div>
  );
}

NeedStiffenerBar.defaultProps = {
  inputId: 'pallet_need_top_hat',
  required: true,
}
export default NeedStiffenerBar;
